import PropTypes from 'prop-types';

const SoldOption = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <div>
        <label htmlFor="shippingCost">Shipping Cost:</label>
        <input
          type="number"
          step="0.01"
          name="shipping_cost"
          value={formData.shipping_cost}
          onChange={handleChange}
          placeholder="Enter shipping cost"
        />
      </div>
      <div>
        <label htmlFor="salePrice">Sale Price:</label>
        <input
          type="number"
          step="0.01"
          name="sale_price"
          id="sale_price"
          value={formData.sale_price}
          onChange={handleChange}
          placeholder="Enter sale price"
        />
      </div>
    </>
  );
};

SoldOption.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired
};

export default SoldOption;
